<div class="as-built-dashboard">
    <header class="dashboard-header">
        <div>
            <h1>As-Built Drainage Plans</h1>
            <p>Upload a plan for extraction, create a manual portrait drawing, and review generated documents.</p>
        </div>
        <button class="btn-secondary" type="button" (click)="openTraining()">AI Training</button>
    </header>

    <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden>

    <section class="intake-panel">
        <div class="intake-fields">
            <label>
                <span>Title</span>
                <input [ngModel]="title()" (ngModelChange)="title.set($event)" placeholder="As-built for 25 Muster Road">
            </label>
            <div class="mode-toggle" role="group" aria-label="AI extraction mode">
                <button type="button" [class.active]="extractionMode()==='full'" (click)="extractionMode.set('full')">
                    Full AI draft
                </button>
                <button type="button" [class.active]="extractionMode()==='boundary_only'" (click)="extractionMode.set('boundary_only')">
                    Boundary only
                </button>
            </div>
            <p class="intake-note">Create or extract the drawing first. Once it is processed, attach it to a project or job from the document card.</p>
        </div>

        <div class="intake-actions">
            <button class="btn-primary" (click)="fileInput.click()" [disabled]="isUploading()">
                {{ isUploading() ? 'Uploading...' : 'Upload and Extract' }}
            </button>
            <button class="btn-secondary" (click)="createManualPlan()">
                Create Blank Portrait Plan
            </button>
        </div>
    </section>

    <section class="jobs-section">
        <div class="section-heading">
            <h2>Document Queue</h2>
            <span>{{ jobs().length }} records</span>
        </div>

        <div class="jobs-grid" *ngIf="!isLoadingJobs(); else loadingState">
            <article class="job-card" *ngFor="let job of jobs()" (click)="openJob(job)" [class.is-disabled]="job.status !== 'completed'">
                <div class="thumb">
                    <img *ngIf="sourceImageHref(job)" [src]="sourceImageHref(job) || ''" alt="">
                    <span *ngIf="!sourceImageHref(job)">Plan</span>
                </div>

                <div class="job-content">
                    <div class="card-header">
                        <span class="job-status" [ngClass]="jobStatusClass(job)">{{ job.status }}</span>
                        <span class="doc-status">{{ job.doc_status || 'Needs Review' }}</span>
                    </div>

                    <h3>{{ jobTitle(job) }}</h3>
                    <p *ngIf="job.reference_id; else unattachedRef">{{ job.model_type || 'Manual' }} - {{ job.reference_id }}</p>
                    <ng-template #unattachedRef><p class="unattached">Unattached</p></ng-template>
                    <small>{{ formatDate(job.created_at) }}</small>

                    <div class="error-box" *ngIf="job.status === 'error' && job.message">
                        {{ job.message }}
                    </div>
                </div>

                <div class="card-actions">
                    <button class="btn-open" *ngIf="job.status === 'completed'" (click)="openJob(job); $event.stopPropagation()">Open Editor</button>
                    <button class="btn-attach" *ngIf="job.status === 'completed'" (click)="openAttachModal(job, $event)">
                        {{ job.reference_id ? 'Reattach' : 'Attach' }}
                    </button>
                    <button class="btn-processing" *ngIf="job.status === 'processing'" disabled>Processing</button>
                    <button class="btn-delete" (click)="deleteJob(job.id, $event)">Delete</button>
                </div>
            </article>
        </div>

        <ng-template #loadingState>
            <div class="jobs-grid">
                <div class="job-card skeleton" *ngFor="let i of [1,2,3,4]"></div>
            </div>
        </ng-template>
    </section>

    <div class="modal-backdrop" *ngIf="attachModalJob()" (click)="closeAttachModal()">
        <section class="attach-modal" (click)="$event.stopPropagation()">
            <header>
                <div>
                    <span>Attach document</span>
                    <h2>{{ jobTitle(attachModalJob()!) }}</h2>
                </div>
                <button class="modal-close" type="button" (click)="closeAttachModal()">Close</button>
            </header>

            <div class="attach-tabs">
                <button type="button" [class.active]="attachTab() === 'Project'" (click)="setAttachTab('Project')">Projects</button>
                <button type="button" [class.active]="attachTab() === 'Job'" (click)="setAttachTab('Job')">Jobs</button>
            </div>

            <div class="attach-list" *ngIf="!isLoadingAttachList(); else attachLoading">
                <button type="button" class="attach-item" *ngFor="let item of attachList()" (click)="attachToReference(item)">
                    <strong>{{ referenceTitle(item) }}</strong>
                    <span>{{ item.address || item.site_address || item.customer_name || item.status || item.id }}</span>
                </button>
                <div class="empty-state" *ngIf="attachList().length === 0">No {{ attachTab().toLowerCase() }} records found.</div>
            </div>

            <ng-template #attachLoading>
                <div class="attach-loading">Loading {{ attachTab().toLowerCase() }} records...</div>
            </ng-template>
        </section>
    </div>
</div>
